var ExcelTemplate = function () { return import('~/pages/template-manage/excel-template.vue'); };
var MessageTemplate = function () { return import('~/pages/template-manage/message-template.vue'); };
var LetterTemplate = function () { return import('~/pages/template-manage/letter-template.vue'); };
var MailTemplate = function () { return import('~/pages/template-manage/mail-template.vue'); };
var SpeechTemplate = function () { return import('~/pages/template-manage/speech-template.vue'); };
export default [
    {
        path: '/template-manage/excel-template',
        name: 'excel-template',
        component: ExcelTemplate,
    },
    {
        path: '/template-manage/message-template',
        name: 'message-template',
        component: MessageTemplate,
    },
    {
        path: '/template-manage/letter-template',
        name: 'letter-template',
        component: LetterTemplate,
    },
    {
        path: '/template-manage/mail-template',
        name: 'mail-template',
        component: MailTemplate,
    },
    {
        path: '/template-manage/speech-template',
        name: 'speech-template',
        component: SpeechTemplate,
    },
];
